import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import InputUserItems from "../../components/commons/user/InputUserItems";

function UserModal({ show, toggle, type, action, data, register }) {

    const title = type === "add" ? "Tambah User" : "Edit User"

    return (
        <>
            <Modal isOpen={show} modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}>
                <ModalHeader className="text-extra-bold pt-5"> {title} <span className="close clickable click-in-right" onClick={toggle}>&times;</span></ModalHeader>
                
                

                <ModalBody>
                    <InputUserItems
                        action={action}
                        register={register}
                        data={data}
                        toggle={toggle}
                    />
                </ModalBody>
                <ModalFooter />
            </Modal>
        </>
    )
}

export default UserModal
